module.exports = __webpack_public_path__ + "img/6.d469a611.png";